import { h, Component } from 'preact';
import Loader from 'components/shared/dynamicPageLoader/loader';
import { joinClasses } from 'utils/utils';

import s from 'components/shared/dynamicPageLoader/dynamicPageLoader.sss';

export const pageTypesCache = {};

export default class DynamicPageLoader extends Component {
	constructor(props) {
		super(props);

		this.activeRequest = 0;
		this.componentKey = 1;
		this.state.components = [];
		this.usePage(props.page, props.data, props.props);
	}

	componentWillReceiveProps(nextProps) {
		if (!this.pagesEqual(nextProps.page, this.props.page)) {
			this.usePage(nextProps.page, nextProps.data, nextProps.props);
		} else {
			this.updateCurrentPageProps(nextProps.props);
		}
	}

	componentWillUnmount() {
		this.unmounted = true;
	}

	pagesEqual(page1, page2) {
		if (page1 === page2) {
			return true;
		}
		if (!page1 || !page2) {
			return false;
		}
		if (page1.id !== page2.id) {
			return false;
		}
		if (page1.page && page2.page && page1.page === page2.page) {
			return true;
		}
		return false;
	}

	updateActiveComponent(component, data, props) {
		let key = this.componentKey++;
		let components = this.state.components;
		this.state.components.forEach(el => {
			if (el.removeTimer) {
				return;
			}
			let removed = false;
			const remove = () => {
				if (this.unmounted || removed) {
					return;
				}
				removed = true;
				this.setState({ components: this.state.components.filter(e => e !== el) });
			};
			el.rendered?.transitionOut?.(remove);
			// How should removeDelay be specified ?
			const desiredDelay = el.rendered?.removeDelay;
			let delay = Number.isFinite(desiredDelay) ? desiredDelay : 500;
			el.removeTimer = setTimeout(remove, delay);
		});
		components = components.concat({
			component,
			key,
			data,
			props
		});
		this.setState({ components, activeKey: key });
	}

	updateCurrentPageProps(props) {
		this.activeProps = props;
		if (!this.state.components.length) {
			return;
		}
		let currentComponent = this.state.components[this.state.components.length - 1];
		currentComponent.props = props;
	}

	async usePage(page, data, props) {
		if (!page || !page.getter) {
			return;
		}
		if (typeof page.getter !== 'function') {
			this.props.onLoad?.();
			const component = page.getter?.default || page.getter;
			return this.updateActiveComponent(component, data, props);
		}
		if (pageTypesCache[page.id]) {
			return this.updateActiveComponent(pageTypesCache[page.id], data, props);
		}
		let activeRequest = ++this.activeRequest;
		this.activeProps = props;
		this.updateActiveComponent(page.loader || Loader, { loader: true });
		const raw = await page.getter();
		const component = raw?.default || raw;

		try {
			this.props.onLoad?.();
		} catch (e) {
			console.error(e);
		}

		pageTypesCache[page.id] = component;
		if (this.activeRequest !== activeRequest) {
			return;
		}
		this.updateActiveComponent(component, data, this.activeProps);
	}

	render(props, state) {
		return (
			<div class={joinClasses(s.container, props.containerClass)}>
				{state.components.map(el => {
					const Page = el.component;
					const active = state.activeKey === el.key;
					return (
						<div
							class={joinClasses({
								s, component: true, active,
								loader: el.data?.loader
							}, props.class)}
							key={el.key}
						>
							<Page page={el.data} ref={e => (el.rendered = e)} {...el.props} />
						</div>
					);
				})}
			</div>
		);
	}
}
